var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.10001,
    height: 11.0001,
    rx: 0.550007,
    transform: "matrix(1 0 -0.00028744 1 9.40222 4.5)",
    fill: "#3C49C6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.10003,
    height: 11,
    rx: 0.550013,
    transform: "matrix(0 -1 1 -0.000287388 4.5 10.6016)",
    fill: "#3C49C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRangeIcon);
export default __webpack_public_path__ + "static/media/add-range-icon.7d6f2614bc1c6b61b7584f3596888e4f.svg";
export { ForwardRef as ReactComponent };